import { IHttpClient } from "../../../lib/http";
import {
  SellingConfigurationDto,
  SellingConfigurationEntity,
  SellingConfigurationSchema,
} from "../domain/sellingConfiguration.entity";
import { AxiosRequestConfig } from "axios";

export interface Paginated<T> {
  total: number;
  limit: number;
  skip: number;
  data: T[];
}

function dtoToEntity(dto: SellingConfigurationDto): SellingConfigurationEntity {
  return {
    ...dto,
    serialized: JSON.stringify(dto),
  };
}

function entityToDto(entity: SellingConfigurationEntity) {
  const fromSerializedJSON = (typeof entity.serialized === "string"
    ? JSON.parse(entity.serialized)
    : entity.serialized) as SellingConfigurationDto;
  SellingConfigurationSchema.parse(fromSerializedJSON);
  return fromSerializedJSON;
}

export async function findSellingConfiguration(
  httpClient: IHttpClient,
  propertyTicker: string
): Promise<SellingConfigurationEntity[]> {
  const dtoPage: Paginated<SellingConfigurationDto> = await httpClient.get<
    Paginated<SellingConfigurationDto>
  >(`/selling-configuration/property/${propertyTicker}`);
  return dtoPage.data.map(dtoToEntity);
}

export async function getSellingConfiguration(
  httpClient: IHttpClient,
  id: string
): Promise<SellingConfigurationEntity> {
  const dto: SellingConfigurationDto = await httpClient.get<SellingConfigurationDto>(
    `/selling-configuration/${id}`
  );
  return dtoToEntity(dto);
}

export async function createSellingConfiguration(
  httpClient: IHttpClient,
  entity: SellingConfigurationEntity
): Promise<void> {
  await httpClient.post(`/selling-configuration`, entityToDto(entity));
}

export async function updateSellingConfiguration(
  httpClient: IHttpClient,
  id: string,
  entity: SellingConfigurationEntity
): Promise<void> {
  await httpClient.put(`/selling-configuration/${id}`, entityToDto(entity));
}

export async function deleteSellingConfiguration(
  httpClient: IHttpClient,
  id: string
): Promise<void> {
  await httpClient.delete(`/selling-configuration/${id}`);
}

export async function sendUpsellEmail(
  httpClient: IHttpClient,
  propertyTicker: string,
  roomStayId: string,
  destinationEmails: string[],
  config?: AxiosRequestConfig
): Promise<void> {
  await httpClient.post(
    `/selling/send-upsell-email/property/${propertyTicker}/room-stay/${roomStayId}`,
    {
      propertyTicker: propertyTicker,
      roomStayId: roomStayId,
      ignoreDefaultRecipients: true,
      destinationEmails: destinationEmails,
      destinationPhones: [],
    },
    config
  );
}

export async function getAvailableSelling(
  httpClient: IHttpClient,
  propertyTicker: string,
  roomStayId: string,
  config?: AxiosRequestConfig
): Promise<Record<string, any>> {
  return httpClient.get(
    `/selling/available-selling/property/${propertyTicker}/room-stay/${roomStayId}`,
    config
  );
}
